import { haversineDistanceMeters } from '../utils/geo';

const OVERPASS_ENDPOINTS = [
  'https://overpass-api.de/api/interpreter',
  'https://overpass.kumi.systems/api/interpreter',
  'https://overpass.openstreetmap.ru/api/interpreter'
];

const AMENITY_TAGS = ['school', 'kindergarten', 'hospital', 'police'];

const buildOverpassQuery = ({ latitude, longitude, radius }) => {
  const amenityFilter = AMENITY_TAGS.map(
    (tag) =>
      `
  node(around:${radius},${latitude},${longitude})[amenity=${tag}];
  way(around:${radius},${latitude},${longitude})[amenity=${tag}];
  relation(around:${radius},${latitude},${longitude})[amenity=${tag}];`
  ).join('\n');

  return `
[out:json][timeout:20];
(
${amenityFilter}
);
out center;
`;
};

const getElementCoordinates = (element) => {
  if (Number.isFinite(element?.lat) && Number.isFinite(element?.lon)) {
    return { latitude: element.lat, longitude: element.lon };
  }

  if (Number.isFinite(element?.center?.lat) && Number.isFinite(element?.center?.lon)) {
    return { latitude: element.center.lat, longitude: element.center.lon };
  }

  return null;
};

const parseNearest = ({ elements = [], latitude, longitude }) => {
  if (!elements.length) {
    return {
      status: 'not_found',
      distanceMeters: null,
      amenity: null,
      title: null
    };
  }

  let nearest = null;

  elements.forEach((element) => {
    const coords = getElementCoordinates(element);
    if (!coords) return;

    const distance = haversineDistanceMeters(
      { latitude, longitude },
      coords
    );

    if (!nearest || distance < nearest.distanceMeters) {
      nearest = {
        status: 'found',
        distanceMeters: distance,
        amenity: element.tags?.amenity || null,
        title: element.tags?.name || null
      };
    }
  });

  return nearest || {
    status: 'not_found',
    distanceMeters: null,
    amenity: null,
    title: null
  };
};

export const checkNearbyInfrastructure = async ({ latitude, longitude, radius = 50 }) => {
  const query = buildOverpassQuery({ latitude, longitude, radius });

  let lastError = null;

  for (const endpoint of OVERPASS_ENDPOINTS) {
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: `data=${encodeURIComponent(query)}`
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const payload = await response.json();
      return parseNearest({ elements: payload?.elements, latitude, longitude });
    } catch (error) {
      lastError = new Error(`${endpoint}: ${error.message}`);
    }
  }

  throw lastError || new Error('Все endpoint Overpass недоступны');
};
